import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Table, Spin, Select } from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "Finance Rule ID",
    dataIndex: "key",
  },
  ,
  {
    title: "Financial Start Period",
    dataIndex: "finStartPeriod",
  },
  {
    title: "Financial End Period",
    dataIndex: "finEndPeriod",
  },
  {
    title: "Financial Year End",
    dataIndex: "finYearEnd",
  },
  {
    title: "Local Currency",
    dataIndex: "localCurrencyCode",
  },
];

const GLA0300 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { financeRuleItems, monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [financeRulesList, setFinanceRulesList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    console.log(searchKey);

    if (!searchKey) {
      setFinanceRulesList(originalList);
      return;
    }
    console.log(originalList);
    const filterBySearch = originalList.filter(
      (item) => item?.key === parseInt(searchKey)
    );
    console.log(filterBySearch);
    setFinanceRulesList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    getFinanceRuleAction(
      { session },
      setFinanceRulesList,
      setOriginalList,
      setIsLoading
    );
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    BOM.HasPermission("CREATE_FINANCIAL_RULE") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getFinanceRuleAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetFinanceRules, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            finStartPeriod: element?.periodStartMonth
              ? monthList[element?.periodStartMonth - 1]
              : "No start month",
            finEndPeriod: element?.periodEndMonth
              ? monthList[element?.periodEndMonth - 1]
              : "No end month",
            finYearEnd: element?.financialYearEndMonth
              ? monthList[element?.financialYearEndMonth - 1]
              : "No year end month",
            localCurrencyCode: element?.localCurrencyCode
              ? element?.localCurrencyCode
              : "No short local currency",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setFinanceRulesList(tempArray.filter((item) => item.disabled === false));
        setFinanceRulesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GetFinanceRules, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              finStartPeriod: element?.periodStartMonth
                ? monthList[element?.periodStartMonth - 1]
                : "No start month",
              finEndPeriod: element?.periodEndMonth
                ? monthList[element?.periodEndMonth - 1]
                : "No end month",
              finYearEnd: element?.financialYearEndMonth
                ? monthList[element?.financialYearEndMonth - 1]
                : "No year end month",
              localCurrencyCode: element?.localCurrencyCode
                ? element?.localCurrencyCode
                : "No short local currency",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0300", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0300", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-gla0300", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_FINANCIAL_RULE") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_FINANCIAL_RULE") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={appLabel.financeRules}
        pageItems={financeRuleItems}
      />

      <Card
        title={`${appLabel.financeRules} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE */}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>
            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Finance Rules ID..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={financeRulesList}
              columns={columns}
              fileName={"Finance Rule List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={financeRulesList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA0300);
